module.exports = __webpack_public_path__ + "img/trophy8.png";